import type { EvidenceTimelineItem } from "@/components/coach/sessionPrep/EvidenceTimelineSection";

export type CoachSelectedEvidenceDetailViewModel = {
  detailText: string;
  contextLine: string | null;
  linkLabel: string | null;
};

export function buildCoachSelectedEvidenceDetail(params: {
  evidence: (EvidenceTimelineItem & { subtype: string | null; meeting_id: string | null }) | null;
  windowOrigin?: string;
}): CoachSelectedEvidenceDetailViewModel {
  const evidence = params.evidence;
  const detailText = evidence?.detail || "No summary available yet.";

  const isQuantitativeReflection = Boolean(
    evidence
    && evidence.source === "Reflection"
    && /presence rating:\s*\d+\/5/i.test(detailText),
  );

  const contextLine = (() => {
    if (!evidence) return null;
    if (isQuantitativeReflection) {
      return "This is a leader-completed reflection rating, not a standalone document.";
    }
    if (evidence.source === "Transcript") {
      return "This summary is generated from the meeting transcript.";
    }
    if (evidence.source === "Artifact") {
      return "This summary references a coach/leader uploaded artifact.";
    }
    return null;
  })();

  const linkLabel = (() => {
    if (!evidence?.link) return null;
    if (isQuantitativeReflection) return "Open related meeting evidence";
    try {
      const url = new URL(evidence.link, params.windowOrigin || "http://localhost");
      if (url.pathname.includes("/coach/post-meeting/")) return "Open transcript source";
      if (url.searchParams.get("section") === "evidence") return "Open related meeting evidence";
    } catch {
      return "Open full source";
    }
    return "Open full source";
  })();

  return {
    detailText,
    contextLine,
    linkLabel,
  };
}
